import React from 'react';
import { twMerge } from 'tailwind-merge';
export var DividerHr = function () { return (React.createElement("div", { className: twMerge('mx-1 h-0.5 w-[1.5vw] flex-shrink-0 bg-gray-200', 'mobile:mx-0 mobile:w-6 mobile:-rotate-90 mobile:transform') })); };
